import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import VuiBox from "components/VuiBox";
import { useVisionUIController, setLayout } from "context";
import { Sidenav } from "components/sidenav/sidenav.component";
import { AppTopbar } from "components/topbar.component";
import { setMiniSidenav } from "context";
import { sidenavData } from "services/constants";
import { vars } from "services/constants";
import poweredBy from "assets/images/powered-by.png";
import './layout.css'

export function DashboardLayout({ children }) {
  const [controller, dispatch] = useVisionUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();


  const closeSidebar = () => miniSidenav && setMiniSidenav(dispatch, false);

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <VuiBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        p: 3,
        position: "relative",
        [breakpoints.only("xs")]: {
          p: 1
        },
        [breakpoints.down("md")]: {
          zIndex: 1,
        },
        [breakpoints.only("md")]: {
          marginLeft: pxToRem(100),
        },
        [breakpoints.up("md")]: {
          marginLeft: miniSidenav ? pxToRem(100) : pxToRem(274),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      <Sidenav items={sidenavData} miniSidenav={miniSidenav} />
      <VuiBox
      >
        <AppTopbar />
        <VuiBox onClick={closeSidebar} className="content">
          {children}
        </VuiBox>
        {vars.poweredBy.enabled && (
          <div className="footer">
            <div>
              <a href={vars.poweredBy.vars.url} target="_blank">
                <img
                  src={poweredBy}
                  className="powered-by-logo"
                  alt=""
                />
              </a>
            </div>
          </div>
        )}

      </VuiBox>
    </VuiBox>
  );
}

DashboardLayout.propTypes = {
  // children: PropTypes.node.isRequired,
};